import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { listTypes, profileTypes } from './prop-types';
import Avatar from './avatar';
import ContributorTooltip from '../../../shared/contributor-tooltip';

const validTypes = PropTypes.oneOf(['circle', 'square']);

const Container = styled.div`
  margin-top: 22px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 52px);
  justify-content: space-between;
  grid-gap: 22px;

  > .vflex {
    max-width: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;

    > a.name {
      margin-top: 7px;
      width: 100%;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font: ${props => props.theme.fontWeightHeavy} 11px/12.2px ${props => props.theme.fontFamilyBody};
      color: ${props => props.theme.bodyColor};

      :hover {
        color: ${props => props.theme.bodyColor};
      }
    }
  }
`;

const Item = ({
  id, type, publicUrl, name, profilePictureUrl,
}) => {
  const { isLarge } = React.useContext(ThemeContext);
  const avatarProps = {
    id,
    publicUrl,
    name,
    type,
    profilePictureUrl,
    clickable: true,
    hoverable: isLarge,
  };
  const [first, next] = name.split(' ');
  const abbrev = `${first} ${(next || '').charAt(0)}`.trim();
  return (
    <div className="vflex">
      <Avatar {...avatarProps} />
      <a className="name" href={publicUrl}>{abbrev}</a>
    </div>
  );
};

Item.propTypes = {
  ...profileTypes,
  type: validTypes.isRequired,
};

export default function GridView({ list, type }) {
  const { isLarge } = React.useContext(ThemeContext);

  return (
    <>
      <Container>
        {list.map(prof => <Item key={prof.id} type={type} {...prof} />)}
      </Container>
      {!!isLarge && list.map(prof => <ContributorTooltip key={prof.id} contributor={prof} />)}
    </>
  );
}

GridView.propTypes = {
  type: validTypes.isRequired,
  list: listTypes.isRequired,
};
